import { NavLink } from "react-router-dom"
import Faq from "./faq"
import { useEffect } from "react"
import { CONTACT_CONFIG } from '../config/contact'

export default function Use() {
    // Utilisation des variables de configuration centralisées
    const contactInfo = CONTACT_CONFIG;
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <>
            {/* Header Section */}
            <section className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] text-white py-8 relative overflow-hidden">
                {/* Background Decoration */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -translate-y-48 translate-x-48"></div>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full translate-y-32 -translate-x-32"></div>
                
                <div className="h-[25vh]"></div>
                <div className="main-content relative z-10">        
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
                            Algemene
                            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                Voorwaarden
                            </span>
                        </h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mb-4">
                        <span className="text-sm">
                            <NavLink
                                to="/"
                                className="transition-all duration-500 hover:text-yellow-400"
                                onClick={scrollToTop}
                            >
                                Home
                            </NavLink> / <span className="text-gray-300">Algemene Voorwaarden</span>
                        </span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-5 sm:py-12 relative overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
                
                <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                    <div className="space-y-8">
                        {/* Section 1 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">1</span>
                                </div>
                                Aanvaarding van de voorwaarden
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Door onze website te bezoeken en onze IPTV-diensten te gebruiken, ga je akkoord met deze Algemene Voorwaarden. Als je niet akkoord gaat met deze voorwaarden, gebruik dan onze site of diensten niet.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#002f9c] to-[#0d47ff] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">2</span>
                                </div>
                                IPTV-diensten
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">

                            TVDIAMONDA biedt IPTV-abonnementen zodat je kunt genieten van een grote verscheidenheid aan kanalen en content. Deze abonnementen zijn ontworpen om een kwalitatieve kijkervaring te bieden zonder dat we je persoonlijke informatie hoeven te verzamelen.
                            </p>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed pt-2">
                                De activeringscodes en installatie-instructies worden je onmiddellijk na je aankoop verstrekt.
                            </p>
                        </div>

                        {/* Section 3 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0d47ff] to-[#1d4ed8] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">3</span>
                                </div>
                                Privacy
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                We verzamelen geen persoonlijke gegevens van onze gebruikers. Dit betekent dat je naam, adres, betalingsgegevens of andere identificeerbare details niet door TVDIAMONDA worden verzameld of opgeslagen. Je privacy is gegarandeerd, en we hebben maatregelen genomen om elke gegevensverzameling door derden te voorkomen.
                            </p>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed pt-2">
                                Door onze diensten te gebruiken, kun je er zeker van zijn dat je activiteiten volledig anoniem en veilig blijven.
                            </p>
                        </div>

                        {/* Section 4 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#1d4ed8] to-[#3b82f6] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">4</span>
                                </div>
                                Betaling
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Betalingen worden verwerkt via beveiligde platforms van derden. TVDIAMONDA slaat geen betalingsgegevens op. Volg de verstrekte instructies om je aankoop veilig af te ronden.
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#3b82f6] to-[#60a5fa] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">5</span>
                                </div>
                                Gebruik van de diensten
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                De IPTV-diensten van TVDIAMONDA zijn uitsluitend bedoeld voor persoonlijk gebruik. Je mag de activeringscodes of de content van onze diensten niet delen, herverdelen of doorverkopen. Elk misbruik kan leiden tot beëindiging van je abonnement zonder terugbetaling.
                            </p>
                        </div>

                        {/* Section 6 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#60a5fa] to-[#93c5fd] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">6</span>
                                </div>
                                Aansprakelijkheid
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                              TVDIAMONDA zet zich in om hoogwaardige IPTV-diensten te leveren. We kunnen echter geen ononderbroken beschikbaarheid garanderen vanwege externe factoren zoals internetstoringen of technische problemen. We aanvaarden geen enkele aansprakelijkheid voor onderbrekingen buiten onze controle.
                            </p>
                        </div>

                        {/* Section 7 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#93c5fd] to-[#bfdbfe] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">7</span>
                                </div>
                                Intellectuele eigendomsrechten
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                Alle content die via onze IPTV-diensten wordt aangeboden, inclusief kanalen, films en series, is beschermd door auteursrecht en intellectuele-eigendomswetgeving. Je mag deze content niet opnemen, verspreiden of kopiëren.
                            </p>
                        </div>

                        {/* Section 8 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#bfdbfe] to-[#dbeafe] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">8</span>
                                </div>
                                Wijzigingen van de voorwaarden
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                We behouden ons het recht voor deze voorwaarden op elk moment te wijzigen. Elke wijziging wordt gepubliceerd op onze website. Door onze diensten te blijven gebruiken na een wijziging, ga je akkoord met de nieuwe voorwaarden.
                            </p>
                        </div>

                        {/* Section 9 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#dbeafe] to-[#eff6ff] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">9</span>
                                </div>
                                Neem contact met ons op
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                                Voor vragen over deze algemene voorwaarden of om je rechten uit te oefenen,
                                kun je contact met ons opnemen via:
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm sm:text-base text-gray-600">
                                <li>Email : {contactInfo.email}</li>
                                <li>
                                    WhatsApp :{" "}
                                    <a
                                        href={contactInfo.whatsappUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 underline hover:text-blue-800 transition-colors duration-300"
                                    >
                                        Klik hier om contact met ons op te nemen
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] rounded-2xl p-6 sm:p-8 text-white shadow-xl">
                            <div className="text-center">
                                <h3 className="text-lg sm:text-xl font-bold mb-4">
                                    Bedankt dat je voor {contactInfo.companyName} kiest
                                </h3>
                                <p className="text-sm sm:text-base leading-relaxed opacity-90">
                                    We zijn er trots op je privacy te garanderen en je een hoogwaardige
                                    service te bieden zonder je veiligheid of anonimiteit in gevaar te brengen.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <Faq/>
            </section>
            
        </>
    )
}   
